import { render, staticRenderFns } from "./PessoaFisicaBase.vue?vue&type=template&id=529703de"
import script from "./PessoaFisicaBase.vue?vue&type=script&lang=js"
export * from "./PessoaFisicaBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports